var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReward(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2836_6138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.666 5.00008H14.8493C14.941 4.74175 14.9993 4.45841 14.9993 4.16675C14.9993 2.78341 13.8827 1.66675 12.4993 1.66675C11.6243 1.66675 10.866 2.11675 10.416 2.79175L9.99935 3.35008L9.58268 2.78341C9.13268 2.11675 8.37435 1.66675 7.49935 1.66675C6.11602 1.66675 4.99935 2.78341 4.99935 4.16675C4.99935 4.45841 5.05768 4.74175 5.14935 5.00008H3.33268C2.40768 5.00008 1.67435 5.74175 1.67435 6.66675L1.66602 15.8334C1.66602 16.7584 2.40768 17.5001 3.33268 17.5001H16.666C17.591 17.5001 18.3327 16.7584 18.3327 15.8334V6.66675C18.3327 5.74175 17.591 5.00008 16.666 5.00008ZM12.4993 3.33341C12.9577 3.33341 13.3327 3.70841 13.3327 4.16675C13.3327 4.62508 12.9577 5.00008 12.4993 5.00008C12.041 5.00008 11.666 4.62508 11.666 4.16675C11.666 3.70841 12.041 3.33341 12.4993 3.33341ZM7.49935 3.33341C7.95768 3.33341 8.33268 3.70841 8.33268 4.16675C8.33268 4.62508 7.95768 5.00008 7.49935 5.00008C7.04102 5.00008 6.66602 4.62508 6.66602 4.16675C6.66602 3.70841 7.04102 3.33341 7.49935 3.33341ZM16.666 15.8334H3.33268V14.1667H16.666V15.8334ZM16.666 11.6667H3.33268V6.66675H7.56602L5.83268 9.02508L7.18268 10.0001L9.99935 6.16675L12.816 10.0001L14.166 9.02508L12.4327 6.66675H16.666V11.6667Z",
    fill: "#2990FB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2836_6138"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReward);
export default __webpack_public_path__ + "static/media/reward.8afa14a09c7244f6c055fccb3c223ad2.svg";
export { ForwardRef as ReactComponent };